module.exports = __webpack_public_path__ + "img/review.9e0104f2.png";